export default function (_, res, next) {
  res.setHeader('Cache-Control', 'no-cache')
  next();
};
